export default "__VITE_ASSET__B74VeFi0__"